import { render, staticRenderFns } from "./CoreHeader.vue?vue&type=template&id=5816c97c&scoped=true"
import script from "./CoreHeader.vue?vue&type=script&lang=js"
export * from "./CoreHeader.vue?vue&type=script&lang=js"
import style0 from "./CoreHeader.vue?vue&type=style&index=0&id=5816c97c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5816c97c",
  null
  
)

export default component.exports